import { useDispatch, useSelector } from 'react-redux'
import { inputs } from '../../../state/slices/formSlice'
import React from 'react'

const Observacoes = (props) => {
    let modulo = props.modulo
    let index = props.index
    let subModulo = props.subModulo
    let indexSub = props.indexSub
    const dispatch = useDispatch()
    const modo = useSelector((state) => state.addForm.modo)
    const ficha = useSelector((state) => state.addForm.ficha)
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const width = mediaWeb ? props.widthWeb : props.widthMobile

    const estilo = {
        principal: {
            marginTop: "2vw", width: width
        },
        label: {
            textAlign: "left", color: "#484848"
        },
        area: {
            backgroundColor: "#00000000", border: "1px solid #00000029", borderRadius: "5px",
            textAlign: "left", width: width, whiteSpace: "pre-line"
        }
    }

    // ==========================
    // Funções auxiliares SHIFT+F3
    // ==========================

    function paraTitleCase(texto) {
        return String(texto ?? '')
            .toLowerCase()
            .replace(/\S+/g, palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    }

    function proximaVariacaoDeCaixa(texto) {
        if (texto === null || texto === undefined) return texto

        const s = String(texto)
        const upper = s.toUpperCase()
        const lower = s.toLowerCase()
        const title = paraTitleCase(s)

        // Ciclo: MAIÚSCULA -> minúscula -> Capitalizado -> MAIÚSCULA...
        if (s === upper) {
            return lower
        } else if (s === lower) {
            return title
        } else {
            return upper
        }
    }

    function handleKeyDown(e) {
        if (!(e.shiftKey && e.key === 'F3')) return

        e.preventDefault()

        const el = e.target
        const fullValue = el.value || ''

        const start = typeof el.selectionStart === 'number' ? el.selectionStart : 0
        const end = typeof el.selectionEnd === 'number' ? el.selectionEnd : 0
        const hasSelection = start !== end

        let nextValue = fullValue

        if (hasSelection) {
            const selected = fullValue.slice(start, end)
            const replaced = proximaVariacaoDeCaixa(selected)

            // troca só o trecho selecionado
            nextValue = fullValue.slice(0, start) + replaced + fullValue.slice(end)

            // atualiza o textarea e mantém a seleção no novo trecho
            el.value = nextValue
            const newEnd = start + String(replaced).length
            el.setSelectionRange(start, newEnd)
        } else {
            // sem seleção: comporta como hoje (texto todo)
            nextValue = proximaVariacaoDeCaixa(fullValue)
            el.value = nextValue

            // mantém o cursor onde estava (se possível)
            const caret = start
            el.setSelectionRange(caret, caret)
        }

        // Envia o valor ajustado para o Redux,
        // imitando a estrutura do "e" usado no onChange original
        const fakeEvent = {
            target: {
                name: e.target.name,
                value: nextValue
            }
        }

        dispatch(inputs({ e: fakeEvent, modulo, index, subModulo, indexSub }))
    }

    return (
        <>{RenderInput()}</>
    )

    function RenderInput() {
        let object = []
        if (ficha[modulo] && ficha[modulo][index]) var valor = ficha[modulo][index][props.nome]
        if (!valor) {
            object.push(
                <div style={estilo.principal}>
                    <div style={estilo.label}>{props.label || "Observações"}</div>
                    <textarea
                        style={estilo.area}
                        name={props.nome}
                        rows="5"
                        onKeyDown={handleKeyDown}
                        onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))}
                    ></textarea>
                </div>
            )
        }
        else if (valor && modo === "view") {
            object.push(
                <div style={estilo.principal}>
                    <div style={estilo.label}>Observações</div>
                    <div style={estilo.area} name="observacoes">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{valor}
                    </div>
                </div>
            )
        }
        else {
            object.push(
                <div style={estilo.principal}>
                    <div style={estilo.label}>Observações</div>
                    <textarea
                        style={estilo.area}
                        name={props.nome}
                        rows="5"
                        defaultValue={valor}
                        onKeyDown={handleKeyDown}
                        onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))}
                    ></textarea>
                </div>
            )
        }
        return object
    }
}

export default Observacoes
